// TicketControlsAdmin (2026-11-04, Lyndon): banned senders with undo, and who may see site history.
import { useCallback, useEffect, useState } from 'react';
import { Alert, Autocomplete, Box, Button, Card, CardContent, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import api from '@/services/api';

function AccountPicker({ label, value, onChange }: { label: string; value: any[]; onChange: (v: any[]) => void }) {
  const [opts, setOpts] = useState<any[]>([]);
  return (
    <Autocomplete multiple size="small" options={opts} value={value} filterOptions={(x) => x} isOptionEqualToValue={(a, b) => a.id === b.id}
      getOptionLabel={(o: any) => o.name || ''} onChange={(_, v) => onChange(v)}
      onInputChange={(_, q) => { if (q.length > 1) api.get('/customers', { params: { search: q, limit: 30 } }).then((r: any) => setOpts((r.data || []).map((c: any) => ({ id: c.id, name: c.name })))).catch(() => {}); }}
      renderInput={(p) => <TextField {...p} label={label} />} sx={{ mb: 2 }} />
  );
}

export default function TicketControlsAdmin() {
  const [bans, setBans] = useState<any[]>([]);
  const [techs, setTechs] = useState<any[]>([]);
  const [tech, setTech] = useState<any>(null);
  const [a, setA] = useState<any>({ system: false, allow: [], deny: [] });
  const [msg, setMsg] = useState('');
  const loadBans = useCallback(() => { api.get('/tech-app/email-bans').then((r: any) => setBans(r.data || [])).catch(() => {}); }, []);
  useEffect(() => { loadBans(); api.get('/technicians').then((r: any) => setTechs(Array.isArray(r.data) ? r.data : (r.data?.items || []))).catch(() => {}); }, [loadBans]);
  useEffect(() => { if (tech) api.get(`/tech-app/history-access/${tech.id}`).then((r: any) => setA(r.data)).catch(() => {}); }, [tech]);
  const label = (t: any) => `${t.first_name || ''} ${t.last_name || ''}`.trim() || t.email || t.name || '';
  const save = async () => {
    try { await api.put(`/tech-app/history-access/${tech.id}`, { system: a.system, allow: a.allow.map((x: any) => x.id), deny: a.deny.map((x: any) => x.id) }); setMsg('Saved.'); }
    catch { setMsg('That did not save.'); }
  };
  const undo = async (id: number) => {
    try { await api.post(`/tech-app/email-bans/${id}/undo`); setMsg('Ban removed.'); loadBans(); }
    catch (e: any) { setMsg(e?.response?.data?.detail || 'That did not save.'); }
  };
  return (
    <Box>
      {msg ? <Alert severity="info" sx={{ mb: 2 }} onClose={() => setMsg('')}>{msg}</Alert> : null}
      <Card sx={{ mb: 2 }}><CardContent>
        <Typography variant="h6" sx={{ mb: 0.5 }}>Who can see site history</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>The deny list always wins. A scheduler can also allow one ticket from the ticket itself.</Typography>
        <Autocomplete size="small" options={techs} value={tech} getOptionLabel={label} onChange={(_, v) => setTech(v)} renderInput={(p) => <TextField {...p} label="Technician" />} sx={{ mb: 2 }} />
        {tech ? <>
          <FormControlLabel control={<Switch checked={!!a.system} onChange={(e) => setA({ ...a, system: e.target.checked })} />} label="Entire system" sx={{ mb: 1, display: 'block' }} />
          <AccountPicker label="Allow these accounts" value={a.allow} onChange={(v) => setA({ ...a, allow: v })} />
          <AccountPicker label="Never show these accounts" value={a.deny} onChange={(v) => setA({ ...a, deny: v })} />
          <Button variant="contained" onClick={save}>Save</Button>
        </> : null}
      </CardContent></Card>
      <Card><CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>Banned email senders</Typography>
        {!bans.length ? <Typography variant="body2" color="text.secondary">No one is banned.</Typography> : null}
        {bans.map((b) => (
          <Stack key={b.id} direction="row" spacing={2} alignItems="center" sx={{ py: 1, borderTop: '1px solid #e2e8f0' }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontWeight: 600 }}>{b.sender}</Typography>
              <Typography variant="caption" color="text.secondary">{b.banned_by} · {b.ticket_number || ''}{b.ip ? ` · IP ${b.ip} in fail2ban` : ''}</Typography>
            </Box>
            <Button size="small" variant="outlined" onClick={() => undo(b.id)}>Undo</Button>
          </Stack>
        ))}
      </CardContent></Card>
    </Box>
  );
}
